import React from "react";
import "./index.scss";
import {strings} from "../../../strings/strings";

export const ContractCheckHeader = () => {

    return (
        <div className={"contract-check-header"}>
            <div className={'contract-check-header__title'}>
                <span className={'name'}>{strings.check.header.name}</span>
                <span className={'description'}>{strings.check.header.description}</span>
            </div>
        </div>
    )
};
